export const SOCKET_VIEWER_INFO = "SOCKET_VIEWER_INFO";
